import { fadeIn, fadeOut } from '@grupoboticario/flora-react-system';
export var OverlayStyles = {
  backgroundColor: '$disabledContent',
  position: 'fixed',
  inset: 0,
  zIndex: '$overlay',
  pointerEvents: 'auto',
  animationDuration: '.3s',
  animationTimingFunction: 'cubic-bezier(0.22, 1, 0.36, 1)',
  '@media (prefers-reduced-motion: reduce)': {
    animationDuration: '1.5s',
    animationTimingFunction: 'linear'
  },
  '&[data-state="open"]': {
    animationName: fadeIn
  },
  '&[data-state="closed"]': {
    animationName: fadeOut
  }
};
export var CloseButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  userSelect: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: '$small',
  position: 'absolute',
  right: '$5',
  top: '$5',
  padding: 0,
  cursor: 'pointer',
  fill: '$nonInteractiveAuxiliar',
  '&:hover': {
    '& svg path': {
      fill: '$linkHover'
    }
  },
  '@mobile': {
    padding: '$2'
  }
};
export var HeaderStyles = {
  padding: '$5',
  color: '$backgroundAltSecondary',
  fontSize: '$subtitleDesk',
  wordWrap: 'break-word',
  width: 'calc(100% - $6)',
  '@mobile': {
    width: '100%'
  }
};
export var BodyStyles = {
  padding: '$5',
  overflowX: 'clip',
  '@mobile': {
    overflowX: 'auto'
  }
};
export var FooterStyles = {
  display: 'flex',
  padding: '$5',
  gap: '$2',
  flexWrap: 'wrap-reverse',
  justifyContent: 'center',
  '@mobile': {
    justifyContent: 'flex-end'
  }
};
export var TriggerStyles = {
  pointerEvents: 'visible'
};
//# sourceMappingURL=styles.js.map